import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { LocatiiServiciiComponent } from './locatii-servicii.component';
import { AddLocatiiServiciiComponent } from './add-locatii-servicii/add-locatii-servicii.component';
import { EditLocatiiServiciiComponent } from './edit-locatii-servicii/edit-locatii-servicii.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MaterialModule } from 'src/app/material.module';

@NgModule({
    declarations: [
        LocatiiServiciiComponent,
        AddLocatiiServiciiComponent,
        EditLocatiiServiciiComponent
    ],
    imports: [
        CommonModule,
        FormsModule,
        ReactiveFormsModule,
        MaterialModule
    ],
    exports: [LocatiiServiciiComponent]
})
export class LocatiiServiciiModule { }
